module.exports = __webpack_public_path__ + "img/rate_rival_b.c9d52971.png";